import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import authUser from 'store/selectors/authUser';
import populateEmployees from 'store/selectors/populateEmployees';
import channels from 'store/app/entities/channels/action';
import currentChannel from 'store/selectors/currentChannel';

// A one-to-one partner is often absent from the employees list. Presence for that
// chat lives on state.users, keyed by the other person's user id (channel._id).
export function directPresence(partner, employee, myId, channelName) {
  const user = partner || employee?.user;
  const isTyping = Boolean(user?.isTyping?.[myId]);
  return {
    isOnline: Boolean(partner ? partner.isOnline : employee?.user?.isOnline),
    typing: isTyping ? employee?.firstName || partner?.firstName || channelName || true : false,
  };
}

const mapStateToProps = state => {
  const channel = currentChannel(state);
  const lastSeen = channel?.lastSeen;
  const isDirect = channel ? channel.isDirect || channel.fake : true;
  const users = Object.values(populateEmployees(state)) || [];
  const employee = isDirect ? users.find(u => u.user?._id === channel._id) : null;
  const myId = authUser(state)?._id;
  const partner = isDirect && channel?._id ? state.users?.[channel._id] : null;
  const direct = isDirect ? directPresence(partner, employee, myId, channel?.name) : null;
  const typingEmployee = isDirect
    ? null
    : users.find(u => u.user?.isTyping && u.user.isTyping[channel._id] && u.user._id !== myId);
  const typing = isDirect ? direct.typing : typingEmployee?.firstName;
  const isOnline = isDirect ? direct.isOnline : false;
  return {
    isDirect,
    userCount: channel?.memberCount || channel?.employees?.length || 0,
    lastSeen,
    isOnline,
    typing,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    channels: bindActionCreators(channels, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
